/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {AnsiUp} from "ansi_up/ansi_up";
import Objects from "toolbox/objects";
import DisplayTime from "./DateTime/DisplayTime.jsx";
import {UI} from "../UIGenerator.jsx";
import IconButtonComponent from "./BasicInputs/IconButtonComponent.jsx";
import Overlay from "./Overlay/Overlay.jsx";
import Map from "./Map.jsx";
import Unique from "toolbox/unique";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import Tooltip from "./Tooltip.jsx";


const ansi_up = new AnsiUp();


class Console extends Component {
    constructor() {
        super();

        this.state = {
            flowLogs: true
        }

        this.scrollContainerRef = React.createRef()
        this.savedScrollPosition = 0
        this.handleScroll = this.handleScroll.bind(this)
    }

    scrollToEnd() {
        setTimeout(() => {
            if (this.state.flowLogs && this.scrollContainerRef.current) {
                this.scrollContainerRef.current.scrollTop = this.scrollContainerRef.current.scrollHeight
            }
        }, 100)
    }

    componentDidUpdate(prevProps) {
        if (!Objects.areEqual(prevProps.logs, this.props.logs)) {

            if (this.scrollContainerRef.current) {
                this.savedScrollPosition = this.scrollContainerRef.current.scrollTop
            }

            const wasAtBottom = this.scrollContainerRef.current && (this.scrollContainerRef.current.scrollHeight - this.scrollContainerRef.current.scrollTop <= this.scrollContainerRef.current.clientHeight + 5)

            if (wasAtBottom) {
                this.setState({flowLogs: true})
            }

            if (!this.state.flowLogs && this.scrollContainerRef.current) {
                setTimeout(() => {
                    if (this.scrollContainerRef.current) {
                        this.scrollContainerRef.current.scrollTop = this.savedScrollPosition
                    }
                }, 0)
            } else {
                this.scrollToEnd()
            }
        }
    }

    componentDidMount() {
        this.scrollToEnd()
        if (this.scrollContainerRef.current) {
            this.scrollContainerRef.current.addEventListener('scroll', this.handleScroll)
        }
    }

    componentWillUnmount() {
        if (this.scrollContainerRef.current) {
            this.scrollContainerRef.current.removeEventListener('scroll', this.handleScroll)
        }
    }

    handleScroll() {
        if (!this.scrollContainerRef.current) return

        const {scrollTop, scrollHeight, clientHeight} = this.scrollContainerRef.current
        const isAtBottom = scrollHeight - scrollTop <= clientHeight + 5

        // Update flowLogs state based on scroll position
        if (isAtBottom && !this.state.flowLogs) {
            this.setState({flowLogs: true})
        } else if (!isAtBottom && this.state.flowLogs) {
            this.setState({flowLogs: false})
        }
    }

    viewLog() {
        let {logs, titel} = this.props

        UI.modal(Unique.newId(10), (state, setState, close) => {
            return (
                <div className={"w-full h-full"}>
                    <Console {...this.props} className={"w-full h-full"} allowMaximizing={false} titel={""}/>
                </div>
            )
        }, (state, close) => {
            close()
        }, {
            title: `View logs ${titel ?? ""}`,
            button: []
        }).open()
    }

    render() {
        let {flowLogs} = this.state
        let {logs, titel = "", className = "", allowMaximizing = true, error = null} = this.props

        return (
            <Overlay
                className={"group/logs"}
                topRight={<div className={"flex"}>
                    {allowMaximizing && (
                        <IconButtonComponent
                            text={"Maximize logs"}
                            size={"md"}
                            iconName={"PiArrowsOutSimple"}
                            className={"opacity-0 group-hover/logs:opacity-100 transition-opacity duration-300 m-2"}
                            onClick={this.viewLog.bind(this)}
                        />
                    )}

                </div>

                }
                bottomRight={<>
                    {flowLogs && (<Tooltip text={"auto Follow logs"} delay={2000}>
                        <span
                            className="size-10 m-2 flex justify-center items-center">
                                    <DisplayIcon iconName={"PiCaretDoubleDown"} className={"text-white"}/>
                                </span>
                        </Tooltip>
                    )}

                </>}
            >
                <div
                    className={`bg-stone-50 text-stone-700 overflow-hidden rounded h-[40rem] w-full flex flex-col ${className}`}>
                    {titel !== "" && (
                        <div
                            className={"text-base font-semibold w-full h-14 p-4 flex items-center justify-between"}>
                            <span>{titel}</span>
                        </div>
                    )}
                    {error && (
                        <div className="bg-red-900 text-red-100 p-2 text-sm">
                            {error}
                        </div>
                    )}
                    <div
                        ref={this.scrollContainerRef}
                        className={"w-full h-full overflow-scroll customScrollbarSmall text-[0.65rem] p-1 selection:text-black"}>
                        <Map lines={logs}>
                            {(dataLine, index) => {

                                if (Objects.isObject(dataLine)) {
                                    return (
                                        <span key={index} className={"flex group hover:bg-stone-300 rounded-sm w-full"}>
                                            <pre className={"grow min-h-2"}
                                                 dangerouslySetInnerHTML={{__html: ansi_up.ansi_to_html(dataLine.log)}}/>
                                            <div
                                                className={"px-2 opacity-15 group-hover:opacity-100 shrink-0 sticky left-0 top-0 select-none"}>
                                                <DisplayTime value={dataLine.time}/>
                                            </div>
                                        </span>
                                    )
                                }

                                return (
                                    <pre key={index} className={"hover:bg-stone-300 rounded-sm min-h-3 w-full"}
                                         dangerouslySetInnerHTML={{__html: ansi_up.ansi_to_html(dataLine)}}/>
                                )
                            }}
                        </Map>
                    </div>
                </div>
            </Overlay>
        )
    }
}

Console.propTypes = {}
Console.defaultProps = {}

export default Console
